<template>
  <div class="x-color-picker__container">
    <el-popover
      v-model="visible"
      placement="top-start"
      title=""
      width="300"
      trigger="manual"
      :disabled="disabled"
    >
      <div v-click-outside="hideDialog">
        <input-color />
        <history-color :history-colors="historyColors" />
        <theme-color />
        <standard-color />
        <more-color />
      </div>

      <el-button slot="reference" @click="showDialog">
        <div
          class="x-color-picker__trigger"
          :style="{
            backgroundColor: value,
            cursor: disabled ? 'none' : 'pointer',
          }"
        ></div>
      </el-button>
    </el-popover>
  </div>
</template>

<script>
import HistoryColor from './components/HistoryColor.vue'
import InputColor from './components/InputColor.vue'
import ThemeColor from './components/ThemeColor'
import StandardColor from './components/StandardColor'
import MoreColor from './components/MoreColor'
import ClickOutside from 'vue-click-outside'

export default {
  name: 'XColorPicker',
  directives: {
    ClickOutside,
  },
  provide() {
    return {
      colorRoot: this,
    }
  },

  components: {
    ThemeColor,
    StandardColor,
    MoreColor,
    InputColor,
    HistoryColor,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },

    value: {
      type: String,
      default: '#000000',
    },

    colorBlockSize: {
      type: Number,
      default: 20,
    },
  },

  data() {
    return {
      historyColors: [],
      visible: false,
    }
  },

  mounted() {},

  methods: {
    showDialog() {
      const str = localStorage.getItem('LOCAL_COLOR_KEY')
      this.historyColors = str ? str.split(',').slice(0, 10) : []

      setTimeout(() => {
        this.visible = true
      }, 100)
    },
    hideDialog() {
      this.visible = false
    },
    _change(val) {
      this.$emit('input', val)
      this.$emit('change', val)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep * {
  margin: 0;
  padding: 0;
}
::v-deep li {
  list-style: none;
}
::v-deep input[type='color'] {
  margin-left: 5px;
}
</style>

<style lang="scss">
$border-radius: 4px;
.x-color-picker__container {
  position: relative;
  // width: 30px;
  // height: 30px;
}
.x-color-picker__trigger {
  width: 30px;
  height: 30px;
  box-sizing: border-box;
  background-color: #000000;
  border: 1px solid #e6e6e6;
  border-radius: $border-radius;
  cursor: pointer;
}
.x-color-picker__wrapper {
  &:not(:first-of-type) {
    margin-top: 10px;
  }
}
.x-color-picker__title {
  padding: 5px 0 0 5px;
  font-size: 14px;
  text-align: left;
  color: #000;
}
.x-color-picker__children {
  display: flex;
}
.x-color-picker__children-item {
  width: 20px;
  height: 20px;
  margin: 5px 0 0 5px;
  cursor: pointer;
}
</style>
